import { render, staticRenderFns } from "./CampaignItemPaymentItemTypeView.vue?vue&type=template&id=39c029de&scoped=true&"
import script from "./CampaignItemPaymentItemTypeView.vue?vue&type=script&lang=ts&"
export * from "./CampaignItemPaymentItemTypeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c029de",
  null
  
)

export default component.exports